<template>
    <SliceZone :slices="slices" :components="components" />
</template>

<script setup lang="ts">
    import {inject, ref} from 'vue';
    import {SliceZone} from '@prismicio/vue';
    import {useAsyncData} from 'nuxt/app';
    import {createError} from '#imports';
    import {usePrismicDocument} from '~/composables/content/usePrismicDocument';
    import {useABTestSlices} from '~/composables/useABTestSlices';
    import {PRISMIC_DOCUMENT} from '~/keys';
    import {components} from '~/slices/components';

    const props = defineProps<{
        pageType: string;
    }>();

    const {fetchDocument} = usePrismicDocument(props.pageType);
    const document = inject(PRISMIC_DOCUMENT, ref());
    const {data, error} = await useAsyncData('parent-page-' + props.pageType, () => fetchDocument(), {deep: true});
    if (error.value) {
        throw createError(error.value);
    }
    document.value = data.value!;

    const {slices} = useABTestSlices(document.value);
</script>

<style lang="scss">
    @use '~/assets/styles/page';
    @include page.page-style;
</style>
